export enum MediaType {
  YOUTUBE_VIDEO = "YOUTUBE_VIDEO",
  VIDEO = "VIDEO",
  IMAGE = "IMAGE",
}

export interface Media {
  id: string | number;
  url: string;
  mediaType: MediaType;
  altText?: string;
}